import type { ITrainingApply } from "@bbj-types/apply/training";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "../axios";

export interface IGetTrainingAppliesByCandidateParams {
  limit: number;
  skip: number;
}

export interface IGetTrainingAppliesByCandidate {
  data: ITrainingApply[];
  skip: number;
  limit: number;
  total: number;
}

export const useGetTrainingAppliesByCandidate = () => {
  const [state, execute, cancel] = axios<IGetTrainingAppliesByCandidate, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId, params: IGetTrainingAppliesByCandidateParams) => {
      return execute({
        url: `/applies/training/candidate/${candidateId}`,
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
